export default __webpack_public_path__ + "static/rajendra-b5a52c58fb59c25a0edc2d06aa98bea5.jpg";